import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addNewsletter } from "../Store/ActionCreators/NewsletterActionCreator";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email) return alert("Email is required");

    dispatch(addNewsletter({ email }));
    setEmail(""); // clear input
  };

  return (
    <section className="newsletter-section">
      <div className="container">
        <div className="newsletter-box">

          {/* LEFT CONTENT */}
          <div className="newsletter-text">
            <h3>Stay Updated with Maa Sharde DSK</h3>
            <p>
              सरकारी नौकरी, एडमिट कार्ड, रिजल्ट, योजना और लेटेस्ट अपडेट
              सबसे पहले पाने के लिए हमारे न्यूज़लेटर से जुड़ें।
            </p>
          </div>

          {/* RIGHT FORM */}
          <form className="newsletter-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Subscribe</button>
          </form>

        </div>
      </div>
    </section>
  );
}

